module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded2"
  }, [_vm._v("For:")]), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("Bas, the priestess of Shanville")]), _c('p', {
    staticClass: "ded1"
  }, [_vm._v(" OBE’s (Order of the Bloody Entrails) to: Emma “Morrigan” Bradshaw")]), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Geraldine “sarsaparilla” Stroud Mary “Macha” Byrne")]), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("Hewn into shape by:")]), _c('p', {
    staticClass: "ded"
  }, [_vm._v(" Stella “seanachaidh” Paskins")]), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("Fellow questers: the Christopher McLittle clan")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17157fa2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bec_dedi-1.vue
// module id = 66
// module chunks = 0